module.exports = __webpack_public_path__ + "static/media/arrow-white-down.ae187f4e.svg";